import { Button, EmptyState, ErrorState } from "@helmr/ui";
import type { UseQueryResult } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { isApiError } from "../../api/client";
import { NoAccess } from "../../app/NoAccess";
import { strings } from "../../app/strings";
import { home } from "./strings";

/**
 * One card, one fate. 404 = the API behind this card does not exist yet ("Not connected yet");
 * 403 = "You don't have access to this"; anything else = message, Retry and the request id.
 */
export function QueryGate<T>({ query, skeleton, errorTitle, what, children }: {
  query: Pick<UseQueryResult<T>, "data" | "error" | "isPending" | "refetch">;
  skeleton: ReactNode;
  errorTitle: string;
  what: string;
  children: (data: T) => ReactNode;
}) {
  if (query.isPending) return <>{skeleton}</>;
  if (query.error) return <FailureBody error={query.error} title={errorTitle} what={what} onRetry={() => void query.refetch()} />;
  return <>{children(query.data as T)}</>;
}

export function FailureBody({ error, title, what, onRetry }: { error: unknown; title: string; what: string; onRetry: () => void }) {
  if (isApiError(error) && error.status === 404) return <NotConnectedBody what={what} />;
  if (isApiError(error) && error.status === 403) return <NoAccess compact />;
  return <ErrorState compact title={title} message={isApiError(error) ? error.message : strings.signIn.errors.generic} requestId={isApiError(error) ? error.requestId : null} onRetry={onRetry} />;
}

export function NotConnectedBody({ what }: { what: string }) {
  return <EmptyState compact icon="clock" title={home.notConnected} description={strings.states.notConnectedBody(what)} />;
}

export { Button };
